import { Button, ButtonGroup } from "@mui/material"
import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material"
export const NavigationButtons = ({ view_list, goNextPage, goPrevPage }) => {

    return (
        <ButtonGroup size="small">
            <Button disabled={view_list.cur_page === 0} color="light" onClick={goPrevPage} startIcon={<ArrowCircleLeft />}></Button>
            <Button color="light" >{view_list.cur_page + 1}/{view_list.list.length}</Button>
            <Button disabled={view_list.cur_page === view_list.list.length - 1} color="light" onClick={goNextPage} startIcon={<ArrowCircleRight />}></Button>
        </ButtonGroup>
    )
}